export default __webpack_public_path__ + "88cd7d95cc06e9d3a46bae063cf291ba.png";